const testimonials = [
  {
    name: "Dr. Marcus W.",
    location: "Arkansas Nuclear One, Russellville",
    rating: 5,
    text: "Got invited to a nuclear energy conference in Lyon, France with three weeks notice. My passport expired during COVID when I was not traveling internationally. Fast Passport Center had my renewal reviewed, submitted, and back in seven business days. I made the conference without any drama. This is exactly the kind of professional service that nuclear industry professionals need — predictable, fast, and no margin for error.",
    service: "Passport Renewal",
  },
  {
    name: "Kayla R.",
    location: "Arkansas Tech University, Russellville",
    rating: 5,
    text: "I got accepted to ATU's study-abroad program in Madrid with six weeks to spare, but I had never had a passport before. I had no idea I needed to visit a clerk in person. Fast Passport Center walked me through every step — which Pope County post office to visit, what forms to bring, everything. I had my passport three weeks before departure. Could not have done it without their guidance.",
    service: "New Passport",
  },
  {
    name: "Pastor Dan & Team",
    location: "First Baptist Church, Russellville",
    rating: 5,
    text: "We had four first-time mission team members who had never had a passport and we were leaving for Honduras in four weeks. Fast Passport Center guided all four of them through the process — the clerk visits, the documents, the forms. All four got their passports in time and our team departed on schedule. Incredible support for our church and I will recommend them to every mission leader I know.",
    service: "Group Mission Passports",
  },
];

function Stars({ count }: { count: number }) {
  return (
    <div className="flex items-center gap-0.5">
      {Array.from({ length: count }).map((_, i) => (
        <i key={i} className="ri-star-fill text-[#F6C344] text-sm"></i>
      ))}
    </div>
  );
}

export default function RussellvilleTestimonialsSection() {
  return (
    <section className="bg-[#F7F8FA] py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Reviews</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            What Arkansas River Valley Travelers Say About Our Expedited Passport Service
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto text-base leading-relaxed">
            Real reviews from Russellville, Arkansas Nuclear One, and Arkansas Tech travelers who trusted Fast Passport Center with their expedited passports.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {testimonials.map((t, i) => (
            <div key={i} className="bg-white border border-gray-200 rounded-lg p-6 flex flex-col">
              <Stars count={t.rating} />
              <p className="text-gray-600 text-sm leading-relaxed mt-4 flex-1 italic">
                &ldquo;{t.text}&rdquo;
              </p>
              <div className="mt-5 pt-4 border-t border-gray-200 flex items-center justify-between">
                <div>
                  <p className="font-bold text-[#1A365D] text-sm">{t.name}</p>
                  <p className="text-gray-400 text-xs">{t.location}</p>
                </div>
                <span className="text-xs font-semibold text-[#F6C344] bg-[#F6C344]/10 px-2.5 py-1 rounded-full whitespace-nowrap">
                  {t.service}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}